export const inboxHandler = {
    pathPattern: '/brands/:brandId/inbox',
    toWeb: ({ brandId, threadId }) => ({
        path: `/brands/${brandId}/inbox`,
        query: { threadId },
    }),
    toNative: ({ brandId, threadId }, locationId) => `/${brandId}/${locationId}/inbox/${threadId}`,
    resolve: (pathParams, query) => {
        const threadId = query.get('threadId');
        if (!threadId)
            return null;
        return { key: 'inbox', params: { brandId: pathParams.brandId, threadId } };
    },
    meta: {
        title: 'Inbox thread',
        description: 'Opens a specific support/review thread in the operator Inbox.',
        status: 'live',
        platforms: { web: true, ios: true, android: true },
        flag: null,
        tracked: true,
        trackingKey: 'threadId',
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'threadId', in: 'query', required: true },
            { name: 'locationId', in: 'query', required: false, surface: 'web' },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId', threadId: 'exampleThreadId' },
            locationId: 'exampleLocationId',
        },
    },
};
//# sourceMappingURL=inbox.js.map